import React, { useState } from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { Icon as QuickActionButtonIcon } from "@phosphor-icons/react";
import CustomText from "../../common/general/CustomText/CustomText";
import { colors } from "../../../styles/design-system";

interface QuickActionButtonProps {
  icon: QuickActionButtonIcon;
  title: string;
  onPress?: () => void;
}

const QuickActionButton = ({ icon: Icon, title, onPress }: QuickActionButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const iconStyle = isHovered
    ? { backgroundColor: colors.brand[50], text: colors.brand[200] }
    : { backgroundColor: colors.grey[50] };
  const shadowStyle = isHovered
    ? {
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.05,
        shadowRadius: 2,
        elevation: 1,
        backgroundColor: "#FFFFFFCC",
      }
    : {
        backgroundColor: "#FFFFFF66",
      };

  return (
    <Pressable
      onPress={onPress ? onPress : undefined}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
      style={styles.actionItem}>
      <View style={[styles.quickActionButtonStyle, shadowStyle]}>
        <View style={[styles.actionIconContainer, iconStyle]}>
          <Icon style={{ width: 20, height: 20, color: isHovered ? colors.brand[600] : "" }} />
        </View>
        <CustomText text={title} size="s" weight="normal" useTranslationText={false} style={{ color: "#667085" }} />
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  quickActionButtonStyle: {
    flexDirection: "row",
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    paddingBottom: 12,
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 12,
    borderRadius: 32,
    borderColor: "#EAECF099",
  },
  actionIconContainer: {
    width: 36,
    height: 36,
    backgroundColor: "#f9fafb",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 16,
  },
  actionItem: {
    width: "24%",
  },
});

export default QuickActionButton;
